import { Color, ScreenElement, Timer, vec } from "excalibur";
import { Resources } from "../../resources";
import { LevelOne } from "../../scenes/level-one/level-one";
import { playStart } from "../../util";
import { Die } from "./die";

const padding = 48;

export class DiceDisplay extends ScreenElement {
    private dice: Die[] = [];
    private rolling = false;

    constructor(private level: LevelOne, x: number, y: number, width: number, height: number) {
        super({
            pos: vec(x + padding, y + padding),
            width: width - padding * 2,
            height: height - padding * 2,
        });
    }

    onInitialize() {

    }

    roll(num: number) {
        if (!this.rolling) {
            playStart(Resources.diceShake);

            this.rolling = true;

            this.level.onDiceRolling();

            for (const die of this.dice) {
                this.removeChild(die);
            }

            this.dice = [];

            let dieCounter = 0;

            for (let i = 0; i < 2; i++) {      
                for (let j = 0; j < 2; j++) {
                    if (dieCounter >= num) {
                        break;
                    }
                    
                    const die = new Die(
                        this.level,
                        j * this.width / 2,
                        i * this.width / 2,
                        this.width / 2
                    );

                    this.addChild(die);
                    this.dice.push(die);

                    dieCounter++;
                }         
            }

            const timer = new Timer({ interval: 2000 });

            this.level.add(timer);

            timer.on(() => {
                this.rolling = false;
                playStart(Resources.diceRoll);

                for (const die of this.dice) {
                    die.stop();
                }

                this.level.onDiceRolled(this.dice.map(die => die.face));
            });

            timer.start();
        }   
    }
}